export enum SelectionDestinationTypeHeaderType {
  SELECT_DESTINATION_TYPE,
  ADD_DESTINATION
}
